export const CLEAR_PARTNERS = "clearPartners";
export const SET_PARTNERS = "setPartners";
export const ADD_PARTNER = "addPartner";
export const SET_ERRORS = "setErrors";
export const CLEAR_ERRORS = "clearErrors";
export const UPDATE_PARTNER = "editPartner";
export const MANAGE_LOADING_PARTNERS = "manageLoadingPartners";
export const MANAGE_EDITING_PARTNER = "manageEditingPartner";
